// Pre-Entry Checklist Questions (Attachment 7A)
export const PRE_ENTRY_QUESTIONS = [
    { id: 1, text: 'Have all people involved in this confined space entry been adequately trained to recognize the dangers and know how to control them?' },
    { id: 2, text: 'Do the workers know how to correctly use all equipment required in this confined space entry permit?' },
    { id: 3, text: 'Have all the workers read and do they understand this permit?' },
    { id: 4, text: 'Is the air quality safe for unprotected entry?' },
    { id: 5, text: 'Has the space been tested for the presence of potentially harmful atmospheres?' },
    { id: 6, text: 'Has the space been purged, cleaned, and/or drained of hazardous materials?' },
    { id: 7, text: 'Has the space been isolated from all energy sources (electrical, mechanical, hydraulic, pneumatic, chemical, thermal, etc.)?' },
    { id: 8, text: 'Has all piping that could convey hazardous materials into the space been disconnected, blanked, or blinded?' },
    { id: 9, text: 'Has the space been properly ventilated?' },
    { id: 10, text: 'Is continuous ventilation required during entry?' },
    { id: 11, text: 'Has the space been tested while ventilation equipment was shut down?' },
    { id: 12, text: 'Is continuous air monitoring required during entry?' },
    { id: 13, text: 'Are adequate rescue provisions and equipment immediately available?' },
    { id: 14, text: 'Is there an attendant stationed at the entry point?' },
    { id: 15, text: 'Does the attendant know how to summon rescue and emergency services?' },
    { id: 16, text: 'Is there a means to communicate with the attendant?' },
    { id: 17, text: 'Are the emergency contact numbers readily available?' },
    { id: 18, text: 'Is the entry supervisor available during the entry?' },
    { id: 19, text: 'Have all contractors been briefed on the hazards and emergency procedures?' },
    { id: 20, text: 'Is adequate lighting available for safe entry and work?' },
    { id: 21, text: 'Is electrical equipment rated for the area classification?' },
    { id: 22, text: 'Are proper personal protective equipment (PPE) available and in good condition?' },
    { id: 23, text: 'Has a hot work permit been obtained if required?' },
    { id: 24, text: 'Are fire extinguishers readily available?' },
    { id: 25, text: 'Has the work area been cleared of combustible materials?' },
    { id: 26, text: 'Is all equipment and tools in good working condition?' },
    { id: 27, text: 'Are ladders or other access equipment properly secured?' },
    { id: 28, text: 'Is there adequate means of entry and exit?' },
    { id: 29, text: 'Has the entrance been protected from falling objects?' },
    { id: 30, text: 'Are warning signs and barriers properly posted?' },
    { id: 31, text: 'Have all workers been informed of the location of safety equipment?' },
    { id: 32, text: 'Is the atmospheric testing equipment properly calibrated?' },
    { id: 33, text: 'Have all lockout/tagout procedures been completed?' },
    { id: 34, text: 'Is there a written rescue procedure in place?' },
    { id: 35, text: 'Have rescue team members been notified and are they available?' },
    { id: 36, text: 'Is a retrieval system or retrieval line available if required?' },
    { id: 37, text: 'Has full body harness and retrieval line been inspected?' },
    { id: 38, text: 'Is there a means to promptly summon emergency services?' },
    { id: 39, text: 'Are all workers familiar with the alarm signals?' },
    { id: 40, text: 'Has this permit been reviewed and signed by the entry supervisor?' }
];

// Confined Space Types
export const CONFINED_SPACE_TYPES = [
    { id: 'tank', label: 'Tank' },
    { id: 'pipe', label: 'Pipe' },
    { id: 'manhole', label: 'Manhole' },
    { id: 'tunnel', label: 'Tunnel' },
    { id: 'vault', label: 'Vault' },
    { id: 'other', label: 'Other' }
];

// Permit Types
export const PERMIT_TYPES = [
    { id: 'non-permit', label: 'Non-Permit' },
    { id: 'permit', label: 'Permit' }
];

// Special Requirements - Left column (first 9), Right column (next 9)
export const SPECIAL_REQUIREMENTS = [
    // Left column (0-8)
    { id: 'safetyDeptNotified', label: 'Safety Department Notified' },
    { id: 'adequateAccess', label: 'Adequate Access' },
    { id: 'adequateLighting', label: 'Adequate Lighting (low voltage)' },
    { id: 'attendantRequired', label: 'Attendant Required' },
    { id: 'warningSignsPosted', label: 'Warning Signs Posted @ Access' },
    { id: 'ventilationRequired', label: 'Ventilation Required' },
    { id: 'authorizedEntryLog', label: 'Authorized Entry Log @ Access' },
    { id: 'rescueEquipAvailable', label: 'Rescue Equip/Services Available' },
    { id: 'rescueTeamRequired', label: 'Rescue Team Required' },
    // Right column (9-17)
    { id: 'hotWorkPermitRequired', label: 'Hot Work Permit Required' },
    { id: 'fireExtinguisherAvailable', label: 'Fire Extinguisher Available' },
    { id: 'lifelinesRequired', label: 'Lifelines Required' },
    { id: 'harnessesRequired', label: 'Harnesses Required' },
    { id: 'respiratorsRequired', label: 'Respirators Required' },
    { id: 'airSuppliedRespirators', label: 'Air Supplied Respirators Required' },
    { id: 'protectiveClothing', label: 'Protective Clothing Required' },
    { id: 'communicationsEquip', label: 'Communications Equipment' },
    { id: 'continuousAirMonitoring', label: 'Continuous Air Monitoring' }
];

// Verification Items
export const VERIFICATION_ITEMS = [
    { id: 'lockoutTagout', label: 'Lockout/Tagout' },
    { id: 'purgedCleaned', label: 'Purged/Cleaned/Drained & Ventilated' },
    { id: 'employeeTraining', label: 'Employee Training' }
];

// Air Monitoring Contaminants with PELs
export const AIR_CONTAMINANTS = [
    { id: 'oxygen', label: '% Oxygen (O2)', pel: '19.5% to 23.5%', unit: '%' },
    { id: 'lel', label: 'LEL', pel: 'Less than 10%', unit: '%' },
    { id: 'carbonMonoxide', label: 'Carbon Monoxide (CO)', pel: 'Less than 35 ppm', unit: 'ppm' },
    { id: 'hydrogenSulfide', label: 'Hydrogen Sulfide (H2S)', pel: 'Less than 10 ppm', unit: 'ppm' },
    { id: 'other', label: 'Other', pel: '', unit: '' }
];

// Answer Options for Pre-Entry Checklist
export const ANSWER_OPTIONS = {
    YES: 'yes',
    NO: 'no',
    NA: 'na'
};

// Form Status
export const CSEP_STATUS = {
    NEW: 'new',
    DRAFT: 'draft',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    SUBMITTED: 'submitted'
};

// Mode types for Job/Location toggle
export const MODE_JOB = 'job';
export const MODE_LOCATION = 'location';
